// TODO Refactor name to better reflect meaning of this validation function (maybe call it "not in")
// TODO Write description for every custom validator
/**
 * Validates that a field is required unless another field has a certain value.
 */
export const Validator = {
    name: "required_unless_checked",
    isImplicit: true,
    errorMessage: "This field is required.",
    validate: (value = "", requirement = "") => {
        if (typeof value !== "string") {
            return false;
        }
        const requirementArr = requirement.split(",").filter(val => val !== "");
        const valueArr = value.split(":").filter(val => val !== "");
        if (valueArr.length === 0 || requirementArr.length === 0) {
            return true;
        }
        return !valueArr.some(v => requirementArr.includes(v));
    },
};
